module.exports = __webpack_public_path__ + "static/img/carBg.3fee138d.jpg";